import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import Placeholder from "components/Placeholder";

const Description = ({ description, isLoading }) => {
  if (isLoading) {
    return (
      <>
        <Placeholder variant="text" width="100%" height={24} data-testid="description-placeholder" />
        <Placeholder variant="text" width="100%" height={24} data-testid="description-placeholder" />
      </>
    );
  }

  return <Typography component="p">{description}</Typography>;
};

Description.propTypes = {
  description: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default Description;
